const VARIANT_KEY = 'variant';
const BUY_SELECTOR = '[data-buy-button]';
const VARIANT_DISABLED_CLASS = 'variant-input--disabled';

document.addEventListener('alpine:init', () => {
  Alpine.data('swatchVariantSelector', ({ productId, sectionId, sectionRender = true }) => ({
    disabledMap: {},
    disabledOptions: {},
    hasInitialized: false,
    previousSelectedOptions: {},
    productId,
    productVariants: JSON.parse(document.getElementById(`VariantsJson-${productId}`).textContent),
    optionsValues: JSON.parse(document.getElementById(`OptionsJson-${productId}`).textContent),
    sectionId,
    sectionRender,
    selectedOptions: {},
    swatchselectedVariantId: null,

    init() {
      if (this.hasInitialized) {
        return;
      }

      this.setupSelectedVariant();
      this.setupDisabledMap();
      this.hasInitialized = true;
    },

    get availableVariants() {
      return this.productVariants.filter(variant => variant.available);
    },

    convertArrayToId(array) {
      if (!Array.isArray(array)) {
        array = Array.from(array);
      }

      return array.join('-').replace(' ', '-').toLowerCase();
    },

    currentDisabledId(position, value) {
      const currentSelection = JSON.parse(JSON.stringify(this.selectedOptions));
      currentSelection[position] = value;
      return this.convertArrayToId(Object.values(currentSelection));
    },

    handleVariantChange(event) {
      const el = event.target;

      if (!el.classList.contains('variant-input')) {
        return;
      }

      // update previous to current selected options
      this.previousSelectedOptions = { ...this.selectedOptions };

      // update new selected options
      this.selectedOptions[el.dataset.position] = el.dataset.value;

      this.updateVariant();
    },

    getSelectedOrFirstVariantId() {
      // Check URL for variant param
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get(VARIANT_KEY);

      if (!variantId) {
        return this.availableVariants[0] || this.productVariants[0];
      }

      // Get variant ID from URL
      return this.productVariants.find(variant => variant?.id.toString() === variantId.toString());
    },

    isDisabled(el) {
      if (!el.dataset.position || !el.dataset.value) {
        console.warn('Element is missing position or value attributes:', el);
        return true;
      }

      // Disable the selected position
      const disabledPosition = this.disabledOptions[el.dataset.position]?.toString() || null;
      const isDisabledPosition = disabledPosition && disabledPosition === el.dataset.value.toString();

      // Check if the current combination is disabled
      const currentId = this.currentDisabledId(el.dataset.position, el.dataset.value);
      const isDisabled = this.disabledMap[currentId] || true;
      const notAvailable = el.dataset.available !== 'true';

      // If the element is disabled, set the data-map-key attribute
      el.dataset.mapKey = currentId;

      return (isDisabled && notAvailable) || isDisabledPosition;
    },

    isSelected(position, value) {
      return this.selectedOptions[position].toString() === value.toString();
    },

    optionsDisable() {
      this.disabledOptions = { ...this.selectedOptions };
      Alpine.store('disableAddToCart', true);
    },

    optionsReset() {
      this.disabledOptions = {};
      Alpine.store('disableAddToCart', false);
    },

    setupDisabledMap() {
      // Extract all option values and flatten them into combinations
      const map = {};
      const generateCombinations = (arrays, current = [], index = 0) => {
        if (index === arrays.length) {
          const id = this.convertArrayToId(current);
          map[id] = true;
          return;
        }

        for (const value of arrays[index].values) {
          generateCombinations(arrays, [...current, value], index + 1);
        }
      };

      // Generate all possible combinations of option values
      generateCombinations(this.optionsValues);

      // Update the map with the availability of each variant
      this.productVariants.forEach(variant => {
        const id = this.convertArrayToId(variant.options);
        if (!map[id]) {
          Object.assign(map, { [id]: {} });
        }

        // Set the availability status
        map[id] = !variant.available;
      });

      this.disabledMap = map;
    },

    setupSelectedVariant() {
      const variant = this.getSelectedOrFirstVariantId();
      if (!variant) {
        return;
      }

      this.swatchselectedVariantId = variant.id;
      // Update the hidden input for the variant ID
      this.selectedOptions = {};
      variant.options.forEach((value, index) => {
        this.selectedOptions[(index + 1).toString()] = value;
      });
      this.previousSelectedOptions = this.selectedOptions;

      // Update the hidden input for the variant ID
      const inputEl = document.querySelector(`#swatch-variant-id-${this.productId}`);
      if (inputEl) {
        inputEl.value = this.swatchselectedVariantId;
      }
    },

    filterVariants() {
      const changeArray = Object.entries(this.selectedOptions)
        .find(([key, value]) => this.previousSelectedOptions[key] !== value);
      const filtered = this.productVariants.filter(variant => variant.options[changeArray[0] - 1] === changeArray[1]);
      const available = filtered.filter(v => v.available).map(v => this.convertArrayToId(v.options));
      const disable = filtered.filter(v => !v.available).map(v => this.convertArrayToId(v.options));
      return { available, disable };
    },

    async updateVariant() {
      const selectedOptionsArray = Object.keys(this.selectedOptions)
        .sort()
        .map(key => this.selectedOptions[key]);

      const matchingVariant = this.productVariants.find(variant => variant.options.every((option, index) => option === selectedOptionsArray[index]));

      if (!matchingVariant) {
        const { available, disable } = this.filterVariants();

        disable.forEach(async id => {
          await this.$nextTick();
          const option = document.querySelector(`[data-map-key="${id}"]`);
          if (option) {
            option.classList.add(VARIANT_DISABLED_CLASS);
          }
        });

        available.forEach(async id => {
          await this.$nextTick();
          const option = document.querySelector(`[data-map-key="${id}"]`);
          if (option) {
            option.classList.remove(VARIANT_DISABLED_CLASS);
          }
        });

        this.optionsDisable();
        return;
      }

      this.optionsReset();
      this.updateVariantDetails(matchingVariant);
    },

    updateVariantDetails(matchingVariant) {
      this.swatchselectedVariantId = matchingVariant.id;

      const inputEl = document.querySelector(`#swatch-variant-id-${this.productId}`);
      if (inputEl) {
        inputEl.value = matchingVariant.id;
      }

      // 🚀 Fire custom event with the selected variant media ID
      if (matchingVariant.featured_media && matchingVariant.featured_media.id) {
        window.dispatchEvent(new CustomEvent('variant:change:media', {
          detail: {
            mediaId: matchingVariant.featured_media.id,
          },
        }));
      }

      // Update variant URL
      this.updateUrl(matchingVariant.id);
      this.updateContent(matchingVariant.id);
    },

    updateUrl(variant_id) {
      const url = new URL(window.location.href);
      url.searchParams.set(VARIANT_KEY, variant_id);
      window.history.replaceState({}, '', url.toString());
    },

    async updateContent(variantId) {
      if (!variantId || !this.sectionRender) {
        return;
      }

      // Variant selectors
      const variantSelector = `[data-section="${this.sectionId}"]`;
      const currentVariantSelectors = document.querySelector(variantSelector);

      // Buy buttons
      const currentBuyButton = document.querySelector(BUY_SELECTOR);

      // Construct URL
      const url = new URL(window.location);
      url.searchParams.set(VARIANT_KEY, variantId);
      url.searchParams.set('section_id', this.sectionId);

      fetch(url.toString())
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Replace variant selectors
          const variantSelectors = doc.querySelector(variantSelector);
          currentVariantSelectors.innerHTML = variantSelectors.innerHTML;

          // Replace buy buttons
          const buyButtons = doc.querySelector(BUY_SELECTOR);
          currentBuyButton.innerHTML = buyButtons.innerHTML;
        })
        .catch(error => console.error('Error loading section:', error));
    },
  }));
});
